import { CopyrightOutlined } from '@material-ui/icons'
import React from 'react'

const CopyRight = () => {
    return (
        <div style={{ position: 'fixed', top: '93%', left: '80%', zIndex: 9999 }}>
            <span style={{ color: '#888888', display: 'flex', alignItems: 'center' }}>Copyright <CopyrightOutlined style={{ color: '#888888', marginLeft: 5, marginRight: 5 }} /> 2023 Instalimb Inc.</span>
        </div>
    )
}

export default CopyRight